import { render, staticRenderFns } from "./CarouselForm.vue?vue&type=template&id=8f03615e&scoped=true&"
import script from "./CarouselForm.vue?vue&type=script&lang=js&"
export * from "./CarouselForm.vue?vue&type=script&lang=js&"
import style0 from "./CarouselForm.vue?vue&type=style&index=0&id=8f03615e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f03615e",
  null
  
)

export default component.exports